import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { MagazineTemplateForm } from "../MagazineTemplateForm";
import { CreateMagazineTemplateModalProps } from "./types";
import { useCreateMagazineTemplateModal } from "./controller";

export const CreateMagazineTemplateModal = React.memo(
  ({ modalRef, onComplete }: CreateMagazineTemplateModalProps) => {
    const translate = useTranslate();

    const { methods, mutateAsync, isPending } = useCreateMagazineTemplateModal(
      modalRef,
      onComplete
    );

    return (
      <Modal
        ref={modalRef}
        title={translate("magazine/magazine_template_admin.titles.create")}
        onConfirm={mutateAsync}
        methods={methods}
        isPending={isPending}
      >
        <MagazineTemplateForm />
      </Modal>
    );
  }
);
